import BasePage from "pages/base_page"

export default class NewSessionPage extends BasePage {}
